import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.5",
      fill: "#F5FAFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4 4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M13.707 10.227v9.553c-.227.007-.454.06-.62.16l-1.567.893c-1.093.627-1.993.107-1.993-1.16v-6.486c0-.42.3-.94.673-1.154l2.887-1.653c.166-.093.393-.147.62-.153",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M18.487 12.22v9.553a1.4 1.4 0 0 1-.64-.12l-3.5-1.753a1.4 1.4 0 0 0-.64-.12v-9.553a1.4 1.4 0 0 1 .64.12l3.5 1.753c.18.087.406.127.64.12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M22.667 12.327v6.486c0 .42-.3.94-.674 1.154l-2.886 1.653a1.4 1.4 0 0 1-.62.153V12.22c.226-.007.453-.06.62-.16l1.566-.893c1.094-.627 1.994-.107 1.994 1.16",
      opacity: ".4"
    }, null, -1)
  ]))]))
}
export default { render: render }